import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/application/:id',
    name: 'application',
    component: () =>
      import(/* webpackChunkName: "application" */ '../views/NewApplication.vue'),
  },
  {
    path: '/application-portal/:id',
    name: 'application-portal',
    component: () =>
      import(/* webpackChunkName: "application" */ '../views/NewApplicationPortal.vue'),
  },
  {
    path: '/old-application/:id',
    name: 'old-application',
    component: () =>
      import(/* webpackChunkName: "application" */ '../views/Application.vue'),
  },
  {
    path: '/old-application-portal/:id',
    name: 'application-portal',
    component: () =>
      import(/* webpackChunkName: "application" */ '../views/ApplicationPortal.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
